import { Check, X } from "lucide-react";
import clsx from "@/lib/clsx";

interface Props {
  letter: "A" | "B" | "C" | "D";
  text: string;
  selected: boolean;
  disabled: boolean;
  reveal?: "correct" | "incorrect" | null;
  onSelect: () => void;
}

export default function AnswerButton({ letter, text, selected, disabled, reveal, onSelect }: Props) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      className={clsx(
        "answer-btn",
        selected && "answer-btn-selected",
        reveal === "correct" && "border-emerald-500 bg-emerald-500/10",
        reveal === "incorrect" && "border-rose-500 bg-rose-500/10",
        "disabled:opacity-100"
      )}
    >
      <div className="flex items-start gap-3">
        <span className="font-display text-lg w-8 h-8 rounded-lg bg-steel-700 text-forge-300 flex items-center justify-center shrink-0">
          {letter}
        </span>
        <span className="leading-snug text-base">{text}</span>
        {reveal === "correct" && <Check className="ml-auto w-5 h-5 text-emerald-400 shrink-0" />}
        {reveal === "incorrect" && <X className="ml-auto w-5 h-5 text-rose-400 shrink-0" />}
      </div>
    </button>
  );
}
